// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_TdlB7","bordered":"bordered_fjxn6","toolbarButton":"toolbarButton__9ef0","buttonContainer":"buttonContainer_gf5fI","miniButtons":"miniButtons_eqE6W"};